import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonContainer, Card, FormFieldLabel, Select, Spinner, Textarea } from '@vwfs-bronson/bronson-react';
import { useRemoveCardTitle } from '../../services/common/useRemoveCardTitle';

interface NewConversationCardProps {
  onCancel: () => void;
  onCreate: (title: string, message: string) => void;
  titleOptions?: Array<{ value: string; label: string }>;
  isCreatingNewConversationRequestPending: boolean;
}

export const NewConversationCard: FunctionComponent<NewConversationCardProps> = ({
  onCancel,
  onCreate,
  titleOptions,
  isCreatingNewConversationRequestPending,
}) => {
  const { t } = useTranslation();
  useRemoveCardTitle();
  const [selectedTitle, setSelectedTitle] = useState<string>(titleOptions?.[0]?.value || '');
  const [message, setMessage] = useState<string>('');

  const handleCreate = () => {
    if (selectedTitle.trim() && message.trim()) {
      onCreate(selectedTitle, message);
    }
  };

  return (
    <Card title="" className="u-text-left u-mb">
      <div className="u-mb-small">
        <FormFieldLabel htmlFor="conversation-title-select">{t('newConversationCard:selectTitle')}</FormFieldLabel>
        <Select
          id="conversation-title-select"
          value={selectedTitle}
          onChange={(e) => setSelectedTitle(e.target.value)}
          className="u-mb-small"
        >
          {titleOptions?.map((option) => (
            <Select.Item key={option.value} value={option.value}>
              {option.label}
            </Select.Item>
          ))}
        </Select>
      </div>

      <div className="u-mb">
        <FormFieldLabel htmlFor="conversation-message">{t('newConversationCard:typeYourMessage')}</FormFieldLabel>
        <Textarea
          id="conversation-message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder={t('newConversationCard:enterYourMessage')}
        />
      </div>

      <ButtonContainer nav>
        <Button small onClick={onCancel} type="button" secondary>
          {t('newConversationCard:cancel')}
        </Button>
        <Button small onClick={handleCreate} type="button" disabled={isCreatingNewConversationRequestPending}>
          {isCreatingNewConversationRequestPending ? <Spinner small /> : t('newConversationCard:create')}
        </Button>
      </ButtonContainer>
    </Card>
  );
};
